import { useState } from 'react'
import { useAppStore } from 'lib/hooks/useAppStore'
import { AnimatePresence, motion } from 'motion/react'

import { CloseButton } from 'components/Icons/CloseButton'
import { Login } from './Login'
import { Signup } from './Signup'

export const AccountOverlay = () => {
  const [tab, setTab] = useState<'login' | 'signup'>('login')
  const { setAccountModal } = useAppStore()
  return (
    <div className="fixed inset-0 z-10 p-20">
      <motion.div
        className="absolute inset-0 z-0 bg-blackTransparent backdrop-blur-100 will-change-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          duration: 0.3,
          ease: 'easeIn',
        }}
        onClick={() => setAccountModal(false)}
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          duration: 0.3,
          ease: 'easeIn',
        }}
        className="background-blur relative mx-auto mt-[80px] w-full max-w-[800px] rounded-8 p-16 md:mt-[150px]"
      >
        <div className="relative flex justify-center gap-14 pb-28 pt-20 text-12 leading-120 text-darkGray md:gap-32 md:pb-32 md:text-16">
          <button
            onClick={() => setTab('login')}
            className={`ease transition-opacity duration-200 ${
              tab === 'login' ? 'opacity-100' : 'opacity-50'
            }`}
          >
            Log In
          </button>
          <button
            onClick={() => setTab('signup')}
            className={`ease transition-opacity duration-200 ${
              tab === 'signup' ? 'opacity-100' : 'opacity-50'
            }`}
          >
            Create Account
          </button>
          <button
            className="absolute -top-6 right-0 p-12 uppercase md:right-20 md:top-12"
            onClick={() => setAccountModal(false)}
          >
            <CloseButton />
          </button>
        </div>
        <div className="mt-4 rounded-8 bg-white px-12 py-20">
          <AnimatePresence>
            {tab === 'login' ? <Login /> : null}
            {tab === 'signup' ? <Signup /> : null}
          </AnimatePresence>
        </div>
      </motion.div>
    </div>
  )
}
